import { autoinject, customElement, TaskQueue } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { EventHelper, Subscription } from 'framework/aurelia_tools/event-helper';
import { findLastIndex } from 'framework/script_utilities/array-functions';
import { AccommodationSegment, CitySegment, initAccommodationSegment, initCitySegment, initNoteSegment, initTransportSegment, TravelSegment } from 'model/forms/trip-details';
import { KeywordsService } from 'services/keywords-service';
import { FormSettings } from 'support/shared_models/form-settings';
import { CityChanged } from 'widgets/city-segment';

@autoinject
@customElement('trip-details-section')
export class TripDetailsSectionCustomElement {
  @bindable heading: string = null;
  @bindable intro: string = null;
  @bindable segments: TravelSegment[];
  @bindable disabled = false;
  private subscriptions: Subscription[] = [];

  constructor(private keywords: KeywordsService, private eventHelper: EventHelper, private taskQueue: TaskQueue, private formSettings: FormSettings) { }

  attached() {
    this.subscriptions.push(this.eventHelper.subscribe(CityChanged, e => this.cityChanged(e)));
  }

  detached() {
    this.eventHelper.unsubscribe(this.subscriptions);
  }

  private cityChanged(e: CityChanged) {
    let i = this.segments.indexOf(e.segment);
    while (++i < this.segments.length && this.segments[i].kind !== 'city-segment')
      if (this.segments[i].kind === 'accommodation-segment') {
        const targetSegment = this.segments[i] as AccommodationSegment;
        if (targetSegment.name == null && targetSegment.address == null && (targetSegment.city == null || targetSegment.city.id === e.oldValue?.id)) {
          targetSegment.city = e.segment.city ?? null;
          this.taskQueue.queueMicroTask(() => targetSegment.country = e.segment.country ?? null);
        }
      }
  }

  addCity() {
    const city = initCitySegment();
    this.segments.push(city);
  }

  addTransport() {
    const transport = initTransportSegment({ type: this.keywords.transportTypes[0] ?? null });
    this.segments.push(transport);
  }

  addAccommodation() {
    const lastCitySegmentIndex = findLastIndex(this.segments, s => s.kind === 'city-segment');
    const lastCitySegment = !!~lastCitySegmentIndex ? this.segments[lastCitySegmentIndex] as CitySegment : null;
    const lastCity = lastCitySegment?.city ?? null;
    const lastCountry = lastCity?.country ?? lastCitySegment?.country ?? null;
    const accommodation = initAccommodationSegment({ type: this.keywords.getAccommodationTypes(this.formSettings.formType)[0] ?? null, city: lastCity, cityName: lastCity?.name ?? null, country: lastCountry });
    this.segments.push(accommodation);
  }

  addNote() {
    const note = initNoteSegment();
    this.segments.push(note);
  }
}
